import React from 'react';
import { useStyles } from './styles';

const TooltipBarChart = ({ active, payload, label, children }) => {
  const classes = useStyles();
  if (!active) return null;

  return (
    <div className={classes.container}>
      {children && children(label, payload)}
    </div>
  );
};

export default TooltipBarChart;
